import { Button, SizableText, YStack, isWeb, shadowStandard } from '@my/ui'
import { Copy, CopyCheck, Share2 } from '@tamagui/lucide-icons'
import { ShareModal } from 'app/features/sharing/components'
import { ShareLinkBlock } from './share-link.block'

export interface ShareLinkComponentProps extends ShareLinkBlock {
  copied: boolean
  colour?: string
  onCopyLink: () => void
  onShare: () => void
}
const BackgroundColorMap = {
  white: '$white',
  primary: '$primary',
}
export const ShareLinkComponent = (props: ShareLinkComponentProps) => {
  const backgroundColor = props.shareLinkBackgroundColor
    ? BackgroundColorMap[props.shareLinkBackgroundColor]
    : '$primary'
  return (
    <YStack
      mx="auto"
      width="100%"
      px="$4"
      py="$5"
      my="$5"
      backgroundColor={backgroundColor}
      borderRadius={12}
      maxWidth={450}
      {...shadowStandard}
    >
      <SizableText tag="h4" textAlign="center" mb="$4" size="$8" fow="600">
        {props.shareLinkHeading}
      </SizableText>
      {isWeb ? (
        <ShareModal
          href={props.shareLink}
          subject={props.shareLinkHeading}
          trigger={
            <Button
              theme="black"
              borderRadius={12}
              icon={<Share2 size={24} color="white" />}
              space="$4"
              size="$6"
              fontWeight="500"
            >
              {props.buttonLabel || 'Share'}
            </Button>
          }
        />
      ) : (
        <Button
          theme="black"
          borderRadius={12}
          icon={<Share2 size={24} color="white" />}
          onPress={props.onShare}
          space="$4"
          size="$6"
          fontWeight="500"
        >
          {props.buttonLabel || 'Share'}
        </Button>
      )}

      <Button
        mt="$4"
        fontWeight="500"
        plain
        icon={props.copied ? <CopyCheck size={24} /> : <Copy size={24} />}
        onPress={props.onCopyLink}
      >
        {props.copyLinkLabel || 'Copy Link'}
      </Button>
    </YStack>
  )
}
